import * as Types from '../../../util/graphql/api.graphql';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';

export const UpdateTaskDocument = gql`
  mutation UpdateTask($task: TaskIn!) {
    updateTask(task: $task) {
      id
      __typename
      code {
        coding {
          system
          code
        }
      }
      status
      intent
      for {
        reference
      }
      note {
        text
      }
      lastModified
      input {
        type {
          text
          coding {
            code
            system
            display
          }
        }
        valueReference {
          reference
        }
      }
      output {
        type {
          text
          coding {
            code
            system
            display
          }
        }
        valueString
      }
    }
  }
`;
export type UpdateTaskMutationFn = ApolloReactCommon.MutationFunction<
  UpdateTaskMutationResponse,
  UpdateTaskMutationVariables
>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useUpdateTaskMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateTaskMutationResponse,
    UpdateTaskMutationVariables
  >,
) {
  return ApolloReactHooks.useMutation<
    UpdateTaskMutationResponse,
    UpdateTaskMutationVariables
  >(UpdateTaskDocument, baseOptions);
}
export type UpdateTaskMutationHookResult = ReturnType<
  typeof useUpdateTaskMutation
>;
export type UpdateTaskMutationResult =
  ApolloReactCommon.MutationResult<UpdateTaskMutationResponse>;
export type UpdateTaskMutationOptions = ApolloReactCommon.BaseMutationOptions<
  UpdateTaskMutationResponse,
  UpdateTaskMutationVariables
>;
export type UpdateTaskMutationVariables = Types.Exact<{
  task: Types.TaskIn;
}>;

export type UpdateTaskMutationResponse = {
  __typename: 'Mutation';
  updateTask: {
    __typename: 'Task';
    id?: Types.Maybe<string>;
    status: Types.TaskStatus;
    intent: string;
    lastModified?: Types.Maybe<string>;
    code?: Types.Maybe<{
      __typename: 'CodeableConcept';
      coding?: Types.Maybe<
        Array<{
          __typename: 'Coding';
          system?: Types.Maybe<string>;
          code?: Types.Maybe<string>;
        }>
      >;
    }>;
    for?: Types.Maybe<{
      __typename: 'Reference';
      reference?: Types.Maybe<string>;
    }>;
    note?: Types.Maybe<
      Array<{ __typename: 'Annotation'; text?: Types.Maybe<string> }>
    >;
    input?: Types.Maybe<
      Array<{
        __typename: 'TaskInput';
        type: {
          __typename: 'CodeableConcept';
          text?: Types.Maybe<string>;
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        };
        valueReference?: Types.Maybe<{
          __typename: 'Reference';
          reference?: Types.Maybe<string>;
        }>;
      }>
    >;
    output?: Types.Maybe<
      Array<{
        __typename: 'TaskOutput';
        valueString?: Types.Maybe<string>;
        type: {
          __typename: 'CodeableConcept';
          text?: Types.Maybe<string>;
          coding?: Types.Maybe<
            Array<{
              __typename: 'Coding';
              code?: Types.Maybe<string>;
              system?: Types.Maybe<string>;
              display?: Types.Maybe<string>;
            }>
          >;
        };
      }>
    >;
  };
};
